module.exports = __webpack_public_path__ + "img/back_m_active1.59e0ce14.png";